import { atom } from 'recoil';
import { IMenu } from '../../commons/types/base';

export const reuniaosAtom = atom<IMenu[]>({
  key: 'menus', 
  default: [] as IMenu[],
}); 
